import { http } from './HttpService.js'
import Swal from 'sweetalert2'

export default {
	getMessage(msg) {
        console.log(msg);
        
        Swal.fire({
            title: 'Ocorreu um erro',
            text: msg.data,
            type: 'error',
            showCancelButton: true,
            cancelButtonText: 'Preciso de ajuda!',
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result.value) {
                //ok!
            } else if (
              result.dismiss === Swal.DismissReason.cancel
            ) {
                window.fcWidget.open({ name: "Checkout", replyText: "Olá, preciso de ajuda. " + msg.data });
            }
        })
    }
    
}